import PaymentsContainer from '@components/containers/payments';
import AppLayout from '@layouts/AppLayout';
import { type FC } from 'react';

const Payments: FC = () => (
    <AppLayout>
        <PaymentsContainer />
    </AppLayout>
);

export default Payments;
